import {
    Avatar,
    Box,
    Button,
    ButtonBase,
    Divider,
    ListItemIcon,
    ListItemText,
    MenuItem,
    Popover,
    Typography,
    Dialog,
    DialogTitle,
    DialogContent,
} from "@material-ui/core";
import PasswordIcon from "@material-ui/icons/Password";
// import useMounted from "../../hooks/useMounted";
import type { FC } from "react";
import { useContext, useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { Link as RouterLink, useNavigate } from "react-router-dom";
import ChangePassword from "src/UIS_containers/pages/Authenticate/ChangePassword";
import useAvatar from "../..//hooks/useAvatar";
import useAuth from "../../hooks/useAuth";
import UserIcon from "../../icons/User";
import PasswordResetAmplify from "../authentication/password-reset/PasswordResetAmplify";
import { AuthContext } from "src/contexts/useAuthProvider ";
import Authconfig from "src/config";

// import studentService from '../../UIS_services/StudentService/studentService'

const AccountPopover: FC = () => {
    const anchorRef = useRef<HTMLButtonElement | null>(null);
    const { user, logout } = useAuth();
    const { loginSSO, logoutSSO } = useContext(AuthContext);
    const navigate = useNavigate();
    const [open, setOpen] = useState<boolean>(false);
    const [openDiaglog, setOpenDiaglog] = useState<boolean>(false);
    const avatar = useAvatar();
    // console.log(user);

    // const mounted = useMounted();
    // const [avatar, Setavatar] = useState("");

    // const InitalData = useCallback(async () => {
    //     try {
    //         let data = await studentService.GetAvatar();
    //         if (mounted.current && data) {
    //             Setavatar(data.data);
    //         }
    //     } catch (error) {
    //         toast.error(error.response.data);
    //     }
    // }, [mounted]);

    // useEffect(() => {
    //     InitalData();
    // }, [InitalData]);

    const handleOpen = (): void => {
        setOpen(true);
    };

    const handleClose = (): void => {
        setOpen(false);
    };

    const handleCloseDiaglog = (): void => {
        setOpenDiaglog(false);
    };
    const handleLogout = async (): Promise<void> => {
        try {
            handleClose();
            await logout();
            navigate("/");
        } catch (err) {
            console.error(err);
            toast.error("Unable to logout.");
        }
    };

    // const handleLogoutSSO = async (): Promise<void> => {
    //     try {
    //         window.history.replaceState(null, null, "/login");
    //         sessionStorage.clear();
    //         localStorage.clear();
    //         handleClose();
    //         logoutSSO();
    //     } catch (err) {
    //         console.error(err);
    //         toast.error("Unable to logout.");
    //     }
    // };

    // useEffect(() => {
    //     const handleBeforeUnload = (event) => {
    //         // Check if the user is logged out
    //         // Perform your logic to determine if the user is logged out

    //         event.preventDefault();

    //         // Prompt a message (optional)
    //         event.returnValue = "You are logged out. Closing the tab is recommended.";
    //     };

    //     // Add the event listener when the component mounts
    //     window.addEventListener("beforeunload", handleBeforeUnload);

    //     // Remove the event listener when the component unmounts
    //     return () => {
    //         window.removeEventListener("beforeunload", handleBeforeUnload);
    //     };
    // }, []);

    const handleLogoutSSO = async () => {
        handleClose();
        await logout();
        localStorage.clear();
        window.location.href = 'https://sso6.neu.edu.vn/adfs/oauth2/logout?post_logout_redirect_uri=http%3A%2F%2Flocalhost%3A3000'
    };


    return (
        <>
            <Box
                component={ButtonBase}
                onClick={handleOpen}
                ref={anchorRef}
                sx={{
                    alignItems: "center",
                    display: "flex",
                }}
            >
                <Avatar
                    src={avatar ? avatar : ""}
                    sx={{
                        height: 32,
                        width: 32,
                    }}
                />
            </Box>
            <Popover
                anchorEl={anchorRef.current}
                anchorOrigin={{
                    horizontal: "center",
                    vertical: "bottom",
                }}
                keepMounted
                onClose={handleClose}
                open={open}
                PaperProps={{
                    sx: { width: 240 },
                }}
            >
                <Box sx={{ p: 2 }}>
                    <Typography color="textPrimary" variant="subtitle2">
                        {user.name}
                    </Typography>
                    <Typography
                        color="textSecondary"
                        variant="subtitle2"
                        sx={{ textAlign: "center" }}
                    >
                        {user.FullName}-{user.Id}
                    </Typography>
                </Box>
                <Divider />
                <Box sx={{ mt: 2 }}>
                    {user.Role != "NV" && user.Role != "AD" ? (
                        <MenuItem
                            component={RouterLink}
                            // to={
                            //     user.Role == "SV"
                            //         ? "/student/info"
                            //         : "/professor/info"
                            // }
                            to={"#"}
                        >
                            <ListItemIcon>
                                <UserIcon fontSize="small" />
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    <Typography
                                        color="textPrimary"
                                        variant="subtitle2"
                                    >
                                        Hồ sơ của tôi
                                    </Typography>
                                }
                            />
                        </MenuItem>
                    ) : (
                        <></>
                    )}

                    {/* <MenuItem>
                        <ListItemIcon>
                            <PasswordIcon fontSize="small" />
                        </ListItemIcon>
                        <ListItemText
                            primary={
                                <Typography
                                    color="textPrimary"
                                    variant="subtitle2"
                                >
                                    <Button
                                        onClick={() => {
                                            setOpenDiaglog(true);
                                        }}
                                    >
                                        Đổi mật khẩu
                                    </Button>
                                </Typography>
                            }
                        />
                    </MenuItem> */}
                </Box>
                <Box sx={{ p: 2 }}>
                    <Button
                        color="primary"
                        fullWidth
                        onClick={Authconfig().IsLoginAdfs ? handleLogoutSSO : handleLogout}
                        variant="outlined"
                    >
                        Đăng xuất
                    </Button>
                </Box>
            </Popover>
            {openDiaglog ? (
                <Dialog open={openDiaglog} onClose={handleCloseDiaglog}>
                    <DialogTitle style={{ textAlign: "center" }}>
                        ĐỔI MẬT KHẨU
                    </DialogTitle>
                    <DialogContent>
                        <ChangePassword />
                    </DialogContent>
                </Dialog>
            ) : (
                <></>
            )}
        </>
    );
};

export default AccountPopover;
